import React, { useEffect, useState } from 'react'
import GeneratePDF from '../../common/GeneratePDF'
import moment from 'moment';
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { columnDefsOneA, columnDefsThreeA, columnDefsTwoA, headerColumnDefs } from './DeliveryMemoTableDefs';
import { SAINI_TRAVELS } from '../../../helper/companyIdhardcode';



const DeliveryMemoTblPdf = (props) => {
    const { fromDate, toDate, data, methods } = props
    const { selectedTab, appliedMoreFilter, headerBody, cityInfo, dynamicFilterNames, loginData } = data
    const { getPdfTableBody } = methods
    const [pdfColumns, setPdfColumns] = useState([])
    const [pdfTableData, setPdfTableData] = useState([])
    const [pdfHeaderColumns, setPdfHeaderColmns] = useState([])
    const [totalFilterCols, setTotalFilterCols] = useState(0)
    const [noOfDynamicTbls, setNoOfDynamicTbls] = useState(0)
    const [dynamicHeaders, setDynamicHeaders] = useState([])
    const [dynamicBody, setDynamicBody] = useState([])
    let dynamicHeaderDefs = [
        { header: 'Source City', dataKey: 'sourceCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '236.4px', textAlign: 'left' } },
        { header: 'Destination City', dataKey: 'destinationCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '236.4px', textAlign: 'left' } },
    ]
    let dynamicHeaderBody = [{
        sourceCity: cityInfo.sourceCityName,
        destinationCity: cityInfo.destinationCityName
    }]
    useEffect(() => {
        let pdfCols = []
        let pdfData = []
        let pdfHeaderCols = headerColumnDefs.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
        });
        let totalFilters = Object.keys(appliedMoreFilter).length + 2 //add2 for source and destination cities
        const hiddenCompanyTwelveDeliveryCols = ['AdditionalDeliveryCartage', 'DeliveryChg', 'ExtraHamli', 'DemurrageChg', 'Discount', 'DeliveryGST']
        const senderColumnDefOneA = { headerName: 'Sender Name\nSender No.', exportHead: 'Sender Name\nSender No.', field: 'sendSender', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } }
        const columnDefsOneForCompany = loginData?.intCompanyID === SAINI_TRAVELS
            ? [...columnDefsOneA.slice(0, 5), senderColumnDefOneA, ...columnDefsOneA.slice(5)].filter((col) => !hiddenCompanyTwelveDeliveryCols.includes(col.field))
            : columnDefsOneA
        switch (selectedTab) {
            case 0:
                pdfCols = columnDefsOneForCompany.map((col) => {
                    return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
                });
                pdfData = getPdfTableBody();
                break;
            case 1:
                pdfCols = columnDefsTwoA.map((col) => {
                    return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
                });
                pdfData = getPdfTableBody();
                break;
            case 2:
                pdfCols = columnDefsThreeA.map((col) => {
                    return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
                });
                pdfData = getPdfTableBody();
                break;
        }
        setPdfColumns(pdfCols)
        setPdfTableData(pdfData)
        setPdfHeaderColmns(pdfHeaderCols)
        setTotalFilterCols(totalFilters)
    }, [])
    useEffect(() => {
        let totalFilters = Object.keys(appliedMoreFilter).length + 2 //add2 for source and destination cities
        setTotalFilterCols(totalFilters)
        if (totalFilters > 2) {
            setNoOfDynamicTbls(Math.ceil(totalFilters / 5))
            for (let key in appliedMoreFilter) {
                dynamicHeaderDefs.push({ header: dynamicFilterNames[key], dataKey: key, xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '236.4px', textAlign: 'left' } })
                dynamicHeaderBody[0][key] = appliedMoreFilter[key]
            }
            setDynamicHeaders(dynamicHeaderDefs)
            setDynamicBody(dynamicHeaderBody)

        } else if (totalFilters <= 2) {
            setDynamicHeaders([])
            setDynamicBody([])
        }
    }, [appliedMoreFilter])
    const styles = StyleSheet.create({
        dataRow: {
            flexDirection: "row",
            borderBottom: "1pt solid #A6A8AB",
        },
        dataCell: {
            flex: 1,
            fontSize: '12px',
            fontWeight: 500,
            paddingVertical: 8,
            paddingHorizontal: 5,
            color: '#444'

        },
        headerCell: {
            backgroundColor: '#BFE1FF',
            flex: 1,
            fontSize: '12px',
            fontWeight: 600,
            paddingVertical: 8,
            paddingHorizontal: 5,
            color: "#444"
        },
        subHeadingRow: {
            fontSize: '12px',
            fontWeight: 600,
            paddingVertical: 8,
            paddingHorizontal: 5,
            color: "#444",

        },
        dataSubRow: {
            textAlign: 'right',
            borderBottom: "1pt solid #A6A8AB",
            backgroundColor: '#f1f9ff',
            flexDirection: 'row',
            justifyContent: 'space-between'
        },
    })
    const getDymnamicHeaderTables = () => {
        let tbl = []
        for (let i = 0; i < noOfDynamicTbls; i++) {
            let slice = dynamicHeaders.slice(i * 5, (i + 1) * 5)
            if(slice?.length<5){
                let emptyCols = 5-slice?.length
                for(let i=0;i<emptyCols;i++){
                  slice.push({ header: '', dataKey:`empty-${i}`, xlCol: { dataType: 'string', dataFormatter: null  }, headerSx: { minWidth: '236.4px', textAlign: 'left' } })
                }
              }
            tbl[i] = <View style={{ border: "1pt solid #A6A8AB", marginTop: '10pt' }}>
                <View key={`THeader`} style={styles.dataRow}>
                    {slice?.map((val) => <Text style={{ ...styles.headerCell, ...val.headerSx }}>{val.header}</Text>)}
                </View>
                <View key={`T-Head-Data-${i}`} style={styles.dataRow}>
                    {slice?.map((val, index) => (
                        <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '236.4px' }}>{dynamicBody[0][val.dataKey]}</Text>
                    ))}
                </View>
            </View>
        }
        return tbl
    }

    return (
        <GeneratePDF width={'100%'} height={"440px"} size={[1366, 1929]} orientation={'portrait'} reportName={"Delivery Memo"} generateDate={`${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`} reportView={`Report: Pending Delivery At My Branch`} isSubHeading={true} title={"Delivery Memo"}>
            {
                totalFilterCols === 2 && (
                    <View style={{ border: "1pt solid #A6A8AB", marginTop: '10pt' }}>
                        <View key={`THeader`} style={styles.dataRow}>
                            {pdfHeaderColumns.map((val) => <Text style={{ ...styles.headerCell, ...val.headerSx }}>{val.header}</Text>)}
                        </View>
                        {headerBody?.map((row, index) => (
                            <View key={`T-Head-Data-${index}`} style={styles.dataRow}>
                                <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '30px' }}>{row.sourceCity}</Text>
                                <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '30px' }}>{row.destinationCity}</Text>
                            </View>
                        ))}
                    </View>
                )
            }
            {
                totalFilterCols > 2 && getDymnamicHeaderTables()
            }
            <View style={{ border: "1pt solid #A6A8AB", marginTop: '10pt' }}>
                <View key={`THeader`} style={styles.dataRow}>
                    {pdfColumns.map((val) => <Text style={{ ...styles.headerCell, ...val.headerSx }}>{val.header}</Text>)}
                </View>
            </View>
            {selectedTab === 0 && pdfTableData.map((row, index) => (
                <View key={`TData-${index}`} style={styles.dataRow}>
                    <Text style={{ ...styles.dataCell, textAlign: 'center', minWidth: '30px' }}>{row.srNo}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '128px' }}>{row.LRNOManual}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '100px' }}>{row.PaymentTypeVehicle}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '100px' }}>{row.SrCityBranch}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '100px' }}>{row.DstCityBranch}</Text>
                    {loginData?.intCompanyID === 12 && <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '100px' }}>{row.sendSender}</Text>}
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '100px' }}>{row.sendRec}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '100px' }}>{row.rcvDateChallan}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '55px' }}>{row.Units}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '55px' }}>{row.TotalDues}</Text>
                    {loginData?.intCompanyID !== 12 && <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '45px' }}>{row.AdditionalDeliveryCartage}</Text>}
                    {loginData?.intCompanyID !== 12 && <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '45px' }}>{row.DeliveryChg}</Text>}
                    {loginData?.intCompanyID !== 12 && <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '45px' }}>{row.ExtraHamli}</Text>}
                    {loginData?.intCompanyID !== 12 && <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '47px' }}>{row.DemurrageChg}</Text>}
                    {loginData?.intCompanyID !== 12 && <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '45px' }}>{row.Discount}</Text>}
                    {loginData?.intCompanyID !== 12 && <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '45px' }}>{row.DeliveryGST}</Text>}
                    <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '50px' }}>{row.finalAmount}</Text>
                </View>
            ))}
            {selectedTab === 1 && pdfTableData.map((row, index) => (
                <View key={`TData-${index}`} style={styles.dataRow}>
                    <Text style={{ ...styles.dataCell, textAlign: 'center', minWidth: '30px' }}>{row.srNo}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '128px' }}>{row.LRNOManual}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '100px' }}>{row.PaymentTypeDate}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '100px' }}>{row.DstCityBr}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '100px' }}>{row.SrCityBranch}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '100px' }}>{row.Units}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '100px' }}>{row.TotalDues}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '100px' }}>{row.BranchForDelTrans}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '55px' }}>{row.TransByVehicleNo}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '55px' }}>{row.DriverName}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '45px' }}>{row.Remarks}</Text>
                </View>
            ))}
            {selectedTab === 2 && pdfTableData.map((row, index) => (
                <View key={`TData-${index}`} style={styles.dataRow}>
                    <Text style={{ ...styles.dataCell, textAlign: 'center', minWidth: '32px' }}>{row.srNo}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '135px' }}>{row.LRNOManual}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '148px' }}>{row.PaymentTypeDate}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '148px' }}>{row.DstCityBr}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '148px' }}>{row.SrCityBranch}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '74px' }}>{row.Units}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'right', minWidth: '74px' }}>{row.TotalDues}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '106px' }}>{row.OtherBranchInchargeName}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '106px' }}>{row.OtherBranchIncContactNo}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '105px' }}>{row.VehicleNo}</Text>
                    <Text style={{ ...styles.dataCell, textAlign: 'left', minWidth: '106px' }}>{row.DriverNoName}</Text>
                </View>
            ))}
        </GeneratePDF>
    )
}

export default DeliveryMemoTblPdf
